import { Dispatch } from '@reduxjs/toolkit';
import ApplicationAlert, {
  AlertType,
} from '../../common/domain/ApplicationAlert';
import slice from './alertsSlice';
import { getLogUrl, pollIngestState } from '../../api/ingest';
import { GetUploadDetailsResponse } from '../../common/domain/responses';

// const { actions } = slice;
const { actions } = slice;

//todo: we must use non auth fetch with bucket file downloads
// to be moved into API module
const downloadRowLevelLogs = (url, fileName) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise<void>((resolve, reject) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.download = fileName;
          a.href = url;
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            document.body.removeChild(a);
          }, 1000);
          resolve();
        }),
    );
};

const downloadFileLevelLogs = (
  ingestState: GetUploadDetailsResponse,
  fileName: string,
) => {
  const logContent = (ingestState.logFileLevelExceptions ?? []).join('\n');
  const blob = new Blob([logContent], { type: 'text/html' });
  new Promise<void>((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.download = fileName;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
    }, 1000);
    resolve();
  });
};

const downloadEmptyLogFile = (fileName: string) => {
  const logContent = [];
  const blob = new Blob(logContent, { type: 'text/html' });
  new Promise<void>((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.download = fileName;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
    }, 1000);
    resolve();
  });
};

export default class AlertsActions {
  constructor(private dispatch: Dispatch) {}
  dismiss() {
    this.dispatch(actions.dismiss());
  }

  add(alert: ApplicationAlert) {
    this.dispatch(actions.add(alert));
  }

  goToViewUploadsPage() {
    this.dispatch(actions.goToViewUploadsPage(alert));
  }

  dismissUploadSuccess() {
    this.dispatch(actions.dismiss());
  }

  _pollIngestState(groupId, ingestId, success, error) {
    return new Promise<void>((resolve, reject) => {
      if (success({ logStatus: 'ready' })) resolve();
      if (error()) reject();
    });
  }

  downloadLogs(groupId?: string, ingestId?: string) {
    if (groupId == null || ingestId == null) return;
    this.dispatch(actions.update({ loading: true }));
    pollIngestState(
      ingestId,
      groupId,
      (response) => {
        if (response.logStatus == 'ready') {
          return true;
        }
        return false;
      },
      (response) => {
        if (response.logStatus == null) {
          this.dispatch(actions.update({ loading: false }));
          this.add({
            type: AlertType.INFO,
            body: 'No logs available.',
            header: 'Logs download',
          });
          return true;
        }

        if (response.logStatus == 'nologs') {
          downloadEmptyLogFile(`${ingestId}_filelevel.log`);
          downloadEmptyLogFile(`${ingestId}_rowlevel.log`);
          return true;
        }

        if (response.logStatus == 'error') {
          this.dispatch(actions.update({ loading: false }));
          this.add({
            type: AlertType.INFO,
            body: 'No logs were generated due to server error.',
            header: 'Logs download',
          });
          return true;
        }
        return false;
      },
    )
      .then((ingestState) => {
        downloadFileLevelLogs(ingestState, `${ingestId}_filelevel.log`);
      })
      .then(() => getLogUrl({ groupId, ingestId }))
      .then((result) =>
        downloadRowLevelLogs(result.url, `${ingestId}_rowlevel.log`),
      )
      .then(() => {
        this.dispatch(actions.update({ loading: false }));
      })
      .catch(() => {
        this.dispatch(actions.update({ loading: false }));
      });
  }
}
